var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spm1-title",style:({ backgroundColor: _vm.backgroundColor }),attrs:{"id":_vm.componentId}},[_c('div',{staticClass:"spm1-title-box",style:(_vm.boxStyle)},[_c('span',{staticClass:"spm1-title-text",style:({ color: _vm.titleColor })},[_vm._v(_vm._s(_vm.titleContent))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }